import { diffSchema } from './schema';
import * as rules from './rules';
export * from './rules/types';
export const DiffRule = rules;
export * from './onComplete/types';
export function diff(oldSchema, newSchema, rules = []) {
    const changes = diffSchema(oldSchema, newSchema);
    return rules.reduce((prev, rule) => rule({
        changes: prev,
        oldSchema,
        newSchema,
    }), changes);
}
//# sourceMappingURL=index.js.map